import { useState } from 'react';

export const useDraft = <T>(source: T) => {
  const [draft, setDraft] = useState({ source, value: source });
  if (!Object.is(draft.source, source)) {
    setDraft({ source, value: source });
  }
  const value = Object.is(draft.source, source) ? draft.value : source;
  const setValue = (next: T) => setDraft({ source, value: next });
  return [value, setValue] as const;
};
